export default __webpack_public_path__ + "static/media/ico-buildings.d2541890.svg";